var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_4163_13543)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_4163_13543)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_4163_13543)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 41.375C23.7108 41.375 23.375 41.0392 23.375 40.625V23.0938C23.375 21.3878 24.7628 20 26.4688 20H39.875C40.2892 20 40.625 20.3358 40.625 20.75V38C40.625 38.4142 40.2892 38.75 39.875 38.75C39.4608 38.75 39.125 38.4142 39.125 38V21.5H26.4688C25.5899 21.5 24.875 22.2149 24.875 23.0938V40.625C24.875 41.0392 24.5392 41.375 24.125 41.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 44H26.75C24.889 44 23.375 42.486 23.375 40.625C23.375 38.764 24.889 37.25 26.75 37.25H39.875C40.2892 37.25 40.625 37.5858 40.625 38C40.625 38.4142 40.2892 38.75 39.875 38.75H26.75C25.7161 38.75 24.875 39.5911 24.875 40.625C24.875 41.6589 25.7161 42.5 26.75 42.5H39.875C40.2892 42.5 40.625 42.8358 40.625 43.25C40.625 43.6642 40.2892 44 39.875 44Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 41.375H26.75C26.3358 41.375 26 41.0392 26 40.625C26 40.2108 26.3358 39.875 26.75 39.875H39.875C40.2892 39.875 40.625 40.2108 40.625 40.625C40.625 41.0392 40.2892 41.375 39.875 41.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 38.75C27.0858 38.75 26.75 38.4142 26.75 38V20.75C26.75 20.3358 27.0858 20 27.5 20C27.9142 20 28.25 20.3358 28.25 20.75V38C28.25 38.4142 27.9142 38.75 27.5 38.75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4163_13543",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4163_13543",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4163_13543",
    x1: 60,
    y1: 50.5,
    x2: -8.94069e-8,
    y2: -5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD374E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF495E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.09d62b28f9d0cb081a3ad29dfc47b89a.svg";
export { ForwardRef as ReactComponent };